<template>
  <div class="offer_container">
    <div class="offer_head">
      <h4>{{offer.name}}</h4>
      <!-- <price :default_price="offer.default_price" :default_price_list="offer.default_price_list" class="inline-price"></price> -->
    </div>
    <div class="offer_body_container">
      <slot></slot>
      <slot name="order"></slot>
    </div>
  </div>
</template>
<script>
import Price from "../Offer/Price"
import Agency from "./Agency"
export default {
  props:["offer"],
  components:{
    Price,
    Agency
  },
}
</script>
<style scoped>
.offer_container {
  border-bottom: solid 1px lightgrey;
}

.offer_head {
  border-bottom: solid 1px lightgrey;
}

.offer_body_container {


}

.inline-title, .inline-price {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Contract/Offer.vue